import React from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import { Flipper, Flipped } from 'react-flip-toolkit'

import Button from 'discada/dist/Button'
import Loading from 'discada/dist/Loading'

import InventoryChip from 'components/Chip/InventoryChip'
import VehicleChip from 'components/Chip/VehicleChip'

import FlipChip from 'components/Chip/FlipChip'

import { getLeadDetails } from 'actions/leadActions'
import { Interactions } from 'components/Stats/Interactions'
import ScrollButtons from 'components/widgets/ScrollButtons'

import { addToPageState } from 'actions/pageStateActions'
import { initPins } from 'actions/inventoryActions'
import { getEntity } from 'selectors/entitySelectors'
import { getQuery } from 'selectors/pageStateSelectors'

import LeadHeader from 'components/Lead/LeadHeader'
import LeadList from 'components/Lead/LeadList'
import LeadStory from 'components/Lead/LeadStory'

import './index.scss'

export const POLL_INTERVAL = 10000

export { LeadList }

export class Lead extends React.Component {
  constructor(...args) {
    super(...args)

    this.getLeadDetails = () => this.props.getLeadDetails(this.props.id)

    this.setupPoller = () => {
      this.poller = setInterval(this.getLeadDetails, POLL_INTERVAL)
      this.getLeadDetails()
    }
  }

  componentDidMount() {
    this.setupPoller()
  }

  componentWillUnmount() {
    clearInterval(this.poller)
  }

  render() {
    let { leadDetails, addToPageState, queryParams } = this.props,
      illuminations = get(leadDetails, 'illuminations', []),
      vehicleIds = get(leadDetails, 'summary.vehicleIds', []),
      showInsights = true || Object.keys(queryParams).includes('insight')

    if (isEmpty(leadDetails)) return <Loading />

    return (
      <div className="lead-wrapper">
        <LeadHeader
          {...{
            ...this.props,
            lead: this.props.lead || this.props.leadDetails || {},
          }}
          showStats={!showInsights}
          hideVehicles
        />
        {showInsights && <LeadStory {...leadDetails} />}
        <div className="lead-body">
          <div className="lead-vehicles">
            <Flipper
              flipKey={vehicleIds.join()}
              className="lead-vehicles-inner"
            >
              {vehicleIds.map(k => (
                <Flipped flipId={k} key={k}>
                  <FlipChip
                    front={({ flip, side }) => (
                      <InventoryChip
                        hasFlip={
                          showInsights &&
                          get(leadDetails, `vehicleStories[${k}]`)
                        }
                        flip={flip}
                        side={side}
                        id={k}
                        xonClick={() => addToPageState({ vehicleId: k })}
                        onClick={() => false}
                      />
                    )}
                    back={({ flip, side }) =>
                      leadDetails && (
                        <VehicleChip
                          id={k}
                          className="inventory-chip"
                          hasFlip
                          flip={flip}
                          side={side}
                        >
                          <div className="is-size-7 p-3 m-3">
                            <LeadStory
                              title="While looking at this vehicle..."
                              className="lead-story-chip"
                              stories={get(leadDetails, `vehicleStories.${k}`)}
                            />
                          </div>
                        </VehicleChip>
                      )
                    }
                  />
                </Flipped>
              ))}
            </Flipper>
            <ScrollButtons size="small" container=".lead-vehicles-inner">
              <Button size="small" icon="car">
                <strong>{vehicleIds.length} vehicles</strong> looked at
              </Button>
            </ScrollButtons>
          </div>
          <div className="lead-illuminations">
            <Interactions events={illuminations} noLink />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    leadDetails: getEntity(state, op.id, {}),
    queryParams: getQuery(state),
  }
}

export default connect(
  mapStateToProps,
  { initPins, getLeadDetails, addToPageState },
)(Lead)
